import React from "react";

import { Box, Typography } from "@material-ui/core";

const Title: React.FC = () => {
    return (
        <>
            <Typography variant="h5" component="div">
                Operator
            </Typography>
            <Box paddingTop={2}>
                <Typography variant="subtitle1" component="div">
                    Drill down into headroom potential at the operator level. Use this view to uncover growth opportunities within
                    individual stores or groups, helping to optimise performance and drive additional sales.
                </Typography>
            </Box>
        </>
    );
};

export default Title;
